import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import {
	type DocumentUploadRequestDTO,
	postDocumentV2,
} from "web_myplann/Infrastructure/Api/Api";
import {
	processResponse,
	withTimeout,
} from "web_myplann/Infrastructure/Api/ApiUtils";

const UPLOAD_TIMEOUT_MS = 120_000;

export const useDocumentUploadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			withTimeout(
				(args: { data: DocumentUploadRequestDTO }, options) =>
					postDocumentV2(args.data, options),
				UPLOAD_TIMEOUT_MS,
			),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: DocumentKeys.allLists });
		},
	});
};
